import React, {useEffect, useState} from 'react';
import {Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField} from '@mui/material';
import useAxiosInstance from "../useAxiosInstance";
import Swal from "sweetalert2";
import NavBar from "./NavBar";

const SERIAL = /^[0-9A-Fa-f]{12}$/;

// Units on the QA list are also offered updates uploaded as "QA devices only", so QA updates
// before users. Release a package to everyone from the Updates page once QA signs it off.
export default function QaDevices() {
    const instance = useAxiosInstance();
    const [devices, setDevices] = useState([]);
    const [serial, setSerial] = useState("");
    const [label, setLabel] = useState("");
    const [loading, setLoading] = useState(false);

    const load = () => {
        setLoading(true);
        instance.get("QaDevices").then(setDevices).catch(() => {}).finally(() => setLoading(false));
    };

    useEffect(load, []); // eslint-disable-line react-hooks/exhaustive-deps

    const add = (e) => {
        e.preventDefault();
        if (!SERIAL.test(serial.trim())) return;
        setLoading(true);
        instance.post("QaDevices", {deviceId: serial.trim(), label})
            .then(() => { setSerial(""); setLabel(""); load(); })
            .catch(() => setLoading(false));
    };

    // Confirm naming the unit: one click removed it before, and the list shifting up made a
    // double click remove the next unit too (which then silently stops getting QA updates).
    const remove = (d) => {
        Swal.fire({
            text: `Remove ${d.deviceId}${d.label ? ` (${d.label})` : ""} from the QA list? It will stop getting QA-only updates.`,
            showCancelButton: true, confirmButtonText: "Remove", returnFocus: false,
        }).then((res) => {
            if (!res.isConfirmed) return;
            setLoading(true);
            instance.delete(`QaDevices/${d.id}`).then(load).catch(() => setLoading(false));
        });
    };

    return (
        <div style={{margin: "auto", maxWidth: "1640px"}}>
            <NavBar title="QA devices." loading={loading}/>
            <p className="mx-3 text-muted">
                These units also get updates uploaded as "QA devices only". When QA has checked an update,
                release it to everyone on the Updates page.
            </p>
            <form className="mx-3 mb-3 d-flex gap-2 align-items-start flex-wrap" onSubmit={add}>
                <TextField size="small" label="Unit serial" placeholder="44B7D0E3F7BA" value={serial}
                           error={!!serial && !SERIAL.test(serial.trim())}
                           helperText={serial && !SERIAL.test(serial.trim()) ? "12 hex digits" : " "}
                           onChange={(e) => setSerial(e.target.value)}/>
                <TextField size="small" label="Label (optional)" placeholder="QA bench 1" value={label}
                           helperText=" " onChange={(e) => setLabel(e.target.value)}/>
                <Button type="submit" variant="contained" disabled={!SERIAL.test(serial.trim())}>Add</Button>
            </form>
            <TableContainer component={Paper} className="mx-3 mb-4" style={{width: "auto"}}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Unit serial</TableCell>
                            <TableCell>Label</TableCell>
                            <TableCell>Added (UTC)</TableCell>
                            <TableCell/>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {devices.map(d => (
                            <TableRow key={d.id}>
                                <TableCell style={{fontFamily: "monospace"}}>{d.deviceId}</TableCell>
                                <TableCell>{d.label}</TableCell>
                                <TableCell>{d.createdAt?.replace("T", " ").slice(0, 16)}</TableCell>
                                <TableCell align="right">
                                    <Button size="small" color="error" onClick={() => remove(d)}>Remove</Button>
                                </TableCell>
                            </TableRow>
                        ))}
                        {devices.length === 0 &&
                            <TableRow><TableCell colSpan={4} className="text-muted">No QA devices yet.</TableCell></TableRow>}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}
